export enum EventTypes {
	UPDATE = 'UPDATE',
	// Add more types here
}